@let user = auth();

@if (!user) {
  <button
    #p="ngbPopover"
    popoverClass="popover-login"
    type="button"
    placement="bottom"
    [ngbPopover]="loginForm"
    [autoClose]="'outside'"
    class="rounded-4 d-flex {{ isMobile() ? 'dark-blue-border' : 'success' }}"
  >
    <span c></span>
    <i class="inm-icon-person me-1"></i>
    {{ 'components.main_navigation.login' | translate }}
  </button>

  <ng-template #loginForm>
    <app-login-form [popover]="p" />
  </ng-template>
}

@if (user) {
  <a
    id="user-btn"
    popoverClass="popover-logout"
    class="user-profile"
    #a="ngbPopover"
    [ngbPopover]="loggedUserPanel"
    [autoClose]="false"
  >
    {{ 'hola' | translate }} {{ userName() }}
    <img src="img/icons/dropdown_arrow_white.png" alt="" />
  </a>

  <ng-template #loggedUserPanel>
    <div id="user" class="popOver animated">
      <span class="dismiss" (click)="a.close()">X</span>
      <a class="a-nostyle" (click)="a.close()" [routerLink]="['profile']">
        <h3 class="dark-blue-text unbold m-0">{{ 'my_account' | translate }}</h3>
      </a>

      @if ((user?.markers?.length || 0) > 0) {
        <a class="a-nostyle" (click)="a.close()" [routerLink]="['dashboard']">
          <h3 class="dark-blue-text unbold mt-3 mb-0 cursor-pointer">
            {{ 'Administrar alojamientos' | translate }}
          </h3>
        </a>
      }

      <a class="a-nostyle" (click)="a.close(); logout(a)">
        <h3 class="dark-blue-text unbold mt-3 mb-0 cursor-pointer">
          {{ 'logout' | translate }}
        </h3>
      </a>
    </div>
  </ng-template>
}
